import React from "react";
import { Link } from "react-router-dom";

import { Image, Heading } from "@chakra-ui/react";
import styled from "@emotion/styled";

function Footer() {
  return (
    <div>
      <Image src="/images/logo.png" height="170px" />

      <FooterDiv>
        <div>
          <Heading fontSize="2xl" as="h1" size="2xl" isTruncated>
            Discover Experiences
          </Heading>
          <Link to="/">Privacy policy</Link>
          <Link to="/">Term and conditions</Link>
          <Link to="/">About us</Link>
          <Link to="/">Privacy policy</Link>
          <Link to="/">Term and conditions</Link>
          <Link to="/">About us</Link>
        </div>
        <div>
          <Heading fontSize="2xl" as="h1" size="2xl" isTruncated>
            Join us
          </Heading>
          <Link to="/">Privacy policy</Link>
          <Link to="/">Term and conditions</Link>
          <Link to="/">About us</Link>
          <Link to="/">Privacy policy</Link>
          <Link to="/">Term and conditions</Link>
          <Link to="/">About us</Link>
        </div>
        <div>
          <Heading fontSize="2xl" as="h1" size="2xl" isTruncated>
            Explore new things
          </Heading>
          <Link to="/">Privacy policy</Link>
          <Link to="/">Term and conditions</Link>
          <Link to="/">About us</Link>
          <Link to="/">Privacy policy</Link>
          <Link to="/">Term and conditions</Link>
          <Link to="/">About us</Link>
        </div>
      </FooterDiv>
      <SubFooter>
        <Link to="/">Privacy policy</Link>
        <Link to="/">Term and conditions</Link>
        <Link to="/">About us</Link>
      </SubFooter>
    </div>
  );
}

export default Footer;
const FooterDiv = styled.div`
  height: 30%;
  background-color: #f7f7f7;
  display: flex;

  justify-content: space-evenly;
  flex-wrap: wrap;
  padding: 70px 0px;

  @media (max-width: 521px) {
    flex-direction: column;
  }

  img {
    margin-right: 70px;
    height: 150px;
  }

  h1 {
    margin: 30px 0px;
  }

  div {
    display: flex;
    flex-direction: column;
    margin: 0px 20px;

    a {
      margin-top: 10px;
    }
  }
`;

const SubFooter = styled.div`
  height: 60px;

  background-color: #ee575d;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    margin: 0px 30px;
  }
`;
